exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type='text'][data-v-58a1e44d] {\n  width: 100%;\n  padding: 12px 20px;\n  margin: 4px 0;\n  box-sizing: border-box;\n  border: none;\n  /*background-color: grey;\n      color: white;*/\n}\n.border-encoded[data-v-58a1e44d] {\n  border: 2px solid #cad0d7;\n  border-radius: 5px;\n}\n.name-title[data-v-58a1e44d] {\n  font-size: 14px;\n  font-weight: 500;\n  color: #06263e;\n}\n.date-title[data-v-58a1e44d] {\n  display: inline-flex;\n  justify-content: center !important;\n  font-weight: 500;\n  padding: 4px 0 4px 0;\n  color: rgba(6, 38, 62, 0.74);\n}\n", ""]);

// exports
